module.exports = __webpack_public_path__ + "prod/20261104151832/img/shareIcon.d9ffff07.png";